import React, { Component } from 'react'
import styled from 'styled-components'
import CustomBlockQuote from './blockquote'
import { FaAngleLeft, FaAngleRight } from 'react-icons/lib/fa/'

const iconStyle = {
  width: '40px',
  height: '40px',
  color: '#2a2a2a',
  cursor: 'pointer'
}

class Slider extends Component {
  constructor() {
    super()
    this.state = {
      currentActive: 1
    }

    this.handlePanelChange = this.handlePanelChange.bind(this)
  }

  handlePrev() {
    if (this.state.currentActive === 1) {
      return 3
    } else {
      return this.state.currentActive - 1
    }
  }

  handleNext() {
    if (this.state.currentActive === 3) {
      return 1
    } else {
      return this.state.currentActive + 1
    }
  }

  handlePanelChange(action) {
    let nextPanelId
    switch (action) {
      case 'next':
        nextPanelId = this.handleNext()
        break
      case 'prev':
        nextPanelId = this.handlePrev()
        break
    }

    this.setState({
      currentActive: nextPanelId
    })
  }

  render() {
    const activeClass = 'active panel'
    const hiddenClass = 'hidden panel'
    return (
      <SliderContainer>
        <div
          onClick={() => this.handlePanelChange('prev')}
          id="carousel-trigger"
          className="prev-button"
        >
          <FaAngleLeft style={iconStyle} />
        </div>

        <div
          className={this.state.currentActive === 1 ? activeClass : hiddenClass}
          id="one"
        >
          <CustomBlockQuote>
            <p>
              AppTree Revolution provided a unique platform to configure and
              deploy a mobile application for use with our existing asset
              management system.
            </p>
            <p />
          </CustomBlockQuote>
        </div>
        <div
          className={this.state.currentActive === 2 ? activeClass : hiddenClass}
          id="two"
        >
          <CustomBlockQuote>
            <p>
              Until AppTree, there hasn’t been a good mobile/wireless solution
              to connect to our business systems.
            </p>
            <p />
          </CustomBlockQuote>
        </div>
        <div
          className={this.state.currentActive === 3 ? activeClass : hiddenClass}
          id="three"
        >
          <CustomBlockQuote>
            <p>AppTree has significantly improved our productivity.</p>
            <p />
          </CustomBlockQuote>
        </div>

        <div
          onClick={() => this.handlePanelChange('next')}
          id="carousel-trigger"
          className="next-button"
        >
          <FaAngleRight style={iconStyle} />
        </div>
      </SliderContainer>
    )
  }
}

export default Slider

const SliderContainer = styled.div`
  position: relative;
  height: 200px;

  & .panel {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: fadeIn 1s;

    @media screen and (max-width: 768px) {
      position: relative;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .prev-button {
    position: absolute;
    top: 50px;
    left: 0;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .next-button {
    position: absolute;
    top: 50px;
    right: 0;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  .hidden {
    visibility: hidden;
  }

  .active {
    visibility: visible;
    animation: fadeIn 1s;
  }

  //#one {
  //  visibility: hidden;
  //}
  //#two {
  //  display: none;
  //}
  //#three {
  //  display: none;
  //}
`

/*
var carousel = document.getElementById('carousel');
var slides = 3;
var speed = 7000; // 5 seconds

function carouselHide(num) {
  indicators[num].setAttribute('data-state', '');
  slides[num].setAttribute('data-state', '');

  slides[num].style.opacity=0;
}

function carouselShow(num) {
  indicators[num].checked = true;
  indicators[num].setAttribute('data-state', 'active');
  slides[num].setAttribute('data-state', 'active');

  slides[num].style.opacity=1;
}

function setSlide(slide) {
  return function() {
    // Reset all slides
    for (var i = 0; i < indicators.length; i++) {
      indicators[i].setAttribute('data-state', '');
      slides[i].setAttribute('data-state', '');

      carouselHide(i);
    }

    // Set defined slide as active
    indicators[slide].setAttribute('data-state', 'active');
    slides[slide].setAttribute('data-state', 'active');
    carouselShow(slide);

    // Stop the auto-switcher
    clearInterval(switcher);
  };
}

function switchSlide() {
  var nextSlide = 0;

  // Reset all slides
  for (var i = 0; i < indicators.length; i++) {
    // If current slide is active & NOT equal to last slide then increment nextSlide
    if ((indicators[i].getAttribute('data-state') == 'active') && (i !== (indicators.length-1))) {
      nextSlide = i + 1;
    }

    // Remove all active states & hide
    carouselHide(i);
  }

  // Set next slide as active & show the next slide
  carouselShow(nextSlide);
}

if (carousel) {
  var slides = carousel.querySelectorAll('.slide');
  var indicators = carousel.querySelectorAll('.indicator');

  var switcher = setInterval(function() {
    switchSlide();
  }, speed);

  for (var i = 0; i < indicators.length; i++) {
    indicators[i].addEventListener("click", setSlide(i));
  }
}
*/



// WEBPACK FOOTER //
// ./src/components/UI/slider.jsx